"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Separator } from "@/components/ui/separator";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { Phone, Mail, MapPin, Facebook, Twitter, Instagram } from "lucide-react";
const services = ["Mobile Tyre Fitting", "Emergency Tyre Fitting Leeds", "Puncture Repair", "New & Part Worn Tyres", "Wheel Balancing"];
const areas = ["Leeds", "Headingley", "Roundhay", "Pudsey", "Horsforth", "Morley", "Beeston", "Garforth"];
function FooterLegalMenu() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div className="flex gap-4">
        <div className="h-4 w-16 bg-secondary-foreground/10 animate-pulse rounded" />
        <div className="h-4 w-16 bg-secondary-foreground/10 animate-pulse rounded" />
      </div>;
  }
  if (!menuItems || menuItems.length === 0) {
    return null;
  }
  return <ul className="flex flex-wrap items-center gap-4 md:gap-6 text-sm text-secondary-foreground/70">
      {menuItems.map((item, i) => <li key={item.id} data-index={i}>
          <Link to={item.href || "#"} className="hover:text-primary transition-colors">
            {item.label}
          </Link>
        </li>)}
    </ul>;
}
export default function Footer() {
  return <section id="footer" className="bg-secondary text-secondary-foreground pt-16 pb-8">
      <div className="container mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 lg:gap-8">
          
          {}
          <div className="flex flex-col gap-6">
            <Link to="/">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1647150/img/drive_mobile_tyres_leeds_logo_light.png" alt="Drive Mobile Tyres Leeds" className="h-7 w-auto" />
            </Link>
            <p className="text-secondary-foreground/70 text-sm leading-relaxed max-w-xs">
              24/7 Emergency Tyre Fitting and Repairs. We come to your location fast across Leeds and surrounding areas.
            </p>
          </div>

          {}
          <div>
            <h3 className="font-default font-semibold text-lg mb-5 text-secondary-foreground">Services</h3>
            <ul className="space-y-3 text-sm text-secondary-foreground/70">
              {services.map((service, i) => <li key={i} data-index={i}>
                  <Link to="#" className="hover:text-primary transition-colors inline-flex items-center gap-2">
                    <span className="w-1 h-1 rounded-full bg-primary/50" />
                    {service}
                  </Link>
                </li>)}
            </ul>
          </div>

          {}
          <div>
            <h3 className="font-default font-semibold text-lg mb-5 text-secondary-foreground">Areas Covered</h3>
            <ul className="grid grid-cols-2 gap-y-3 gap-x-4 text-sm text-secondary-foreground/70">
              {areas.map((area, i) => <li key={i} data-index={i} className="flex items-center gap-2">
                  <MapPin className="size-3 text-primary/70" />
                  {area}
                </li>)}
            </ul>
          </div>

          {}
          <div>
            <h3 className="font-default font-semibold text-lg mb-5 text-secondary-foreground">Contact Us</h3>
            <ul className="space-y-4 text-sm text-secondary-foreground/70">
              <li className="flex items-start gap-3">
                <Phone className="size-4 mt-0.5 shrink-0 text-primary" />
                <Link to="tel:01131234567" className="hover:text-primary transition-colors">
                  0113 123 4567
                </Link>
              </li>
              <li className="flex items-start gap-3">
                <Mail className="size-4 mt-0.5 shrink-0 text-primary" />
                <Link to="mailto:info@drivemobiletyresleeds.co.uk" className="hover:text-primary transition-colors">
                  info@drivemobiletyresleeds.co.uk
                </Link>
              </li>
              <li className="flex items-start gap-3">
                <MapPin className="size-4 mt-0.5 shrink-0 text-primary" />
                <span>Leeds, West Yorkshire, LS1 1AB, United Kingdom</span>
              </li>
            </ul>
            
            <div className="flex items-center gap-4 mt-6">
              <Link to="#" className="bg-secondary-foreground/5 hover:bg-primary hover:text-primary-foreground text-secondary-foreground p-2 rounded-full transition-all duration-300">
                <Facebook className="size-4" />
                <span className="sr-only">Facebook</span>
              </Link>
              <Link to="#" className="bg-secondary-foreground/5 hover:bg-primary hover:text-primary-foreground text-secondary-foreground p-2 rounded-full transition-all duration-300">
                <Twitter className="size-4" />
                <span className="sr-only">Twitter</span>
              </Link>
              <Link to="#" className="bg-secondary-foreground/5 hover:bg-primary hover:text-primary-foreground text-secondary-foreground p-2 rounded-full transition-all duration-300">
                <Instagram className="size-4" />
                <span className="sr-only">Instagram</span>
              </Link>
            </div>
          </div>

        </div>

        <Separator className="my-8 bg-secondary-foreground/10" />

        <div className="flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-sm text-secondary-foreground/60 text-center md:text-left">
            &copy; {new Date().getFullYear()} Drive Mobile Tyres Leeds. All rights reserved.
          </p>
          
          <MenuProvider menu_id="17">
            <FooterLegalMenu />
          </MenuProvider>
        </div>
      </div>
    </section>;
}